import Length from '../../../../source/js/shared/models/Geometry/Length';
import { MaximumDecimalPoints } from "@/Models/Validators/MaximumDecimalPoints";
import { MinimumValue } from "@/Models/Validators/MinimumValue";
import { MaximumValue } from "@/Models/Validators/MaximumValue";
import { ShapeConfigurationInterface } from './ShapeConfigurationInterface';
import Rectangle from "../../../../source/js/shared/models/Geometry/Rectangle";
import { ShapeCategory } from '@/types/shapeCategories';

export default class KiteConfiguration implements ShapeConfigurationInterface {
	get_dimension_keys(): string[] {
		return [
			'width',
			'height_top',
			'height_bottom',
		];
	}

	get_modifier_keys(): string[] {
		return [];
	}

	get_maximum_dimensions( maximum_rectangle: Rectangle ): Record<string, Length> {
		const longest_side = maximum_rectangle.get_longest_side();
		const height_top = longest_side.divide(3).in_mm();
		const height_bottom = height_top + ( height_top / 2 );

		return {
			width: maximum_rectangle.get_shortest_side(),
			height_top: new Length(height_top),
			height_bottom: new Length(height_bottom),
		};
	}

	get_labels(): Record<string, string> {
		const { width, height_top, height_bottom } = window.measurementSelectorVariables.i18n.dimensionNames;

		return {
			height_top,
			height_bottom,
			width,
		};
	}

	get_validators(): Record<string, Array<unknown>> {
		return {
			width: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
			height_top: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
			height_bottom: [ MaximumDecimalPoints, MinimumValue, MaximumValue ],
		};
	}

	get_category(): ShapeCategory {
		return 'complex';
	}
}
